var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationRules = function SvgSimpleIllustrationRules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.078,
    y: 11.693,
    width: 31.97,
    height: 10.775,
    rx: 2.5,
    fill: "#FFFAF0",
    stroke: "#002140"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M18.139 14.333h10.99v1.494h-10.99zM18.139 18.258h16.485v1.494H18.139z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.143 13.781a.896.896 0 0 1 .189 1.254l-3.901 5.282-2.803-2.56a.896.896 0 0 1 1.209-1.324l1.334 1.218 2.719-3.681a.896.896 0 0 1 1.253-.189Z",
    fill: "#03D47C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.657,
    y: 25.431,
    width: 31.97,
    height: 10.775,
    rx: 2.5,
    fill: "#FFFAF0",
    stroke: "#002140"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "M22.718 28.071h10.99v1.494h-10.99zM22.718 31.996h16.485v1.494H22.718z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.368 33.584a.777.777 0 0 0 1.098-1.099l-1.78-1.78 1.78-1.78a.777.777 0 0 0-1.098-1.097l-1.78 1.78-1.78-1.781a.777.777 0 0 0-1.098 1.098l1.78 1.78-1.78 1.781a.777.777 0 0 0 1.098 1.098l1.78-1.78 1.78 1.78Z",
    fill: "#F25730"
  })));
};
export default SvgSimpleIllustrationRules;